const global = window

// Remplissage automatique
inputs.behavior.ajax = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.ajax) {
        const pf = input.closest('.window, body')

        if (typeof data.ajax != 'object') {
            data.ajax = {
                url: data.ajax,
            }
        }

        input.addClass('ajaxable')

        // define function
        data.reload = function () {
            if (
                input.hasClass('loading') ||
                input.closest('.loading').length > 0
            )
                return false
            input.addClass('loading')

            const apiDeferreds = []
            pf.find('[data-api]').addBack('[data-api]').each(function() {
                const apiDeferred = $(this).data('apiDeferred')
                if (apiDeferred && apiDeferred.state() === 'pending') {
                    apiDeferreds.push(apiDeferred)
                }
            })

            const proceedWithAjax = () => {
                // console.log('INPUT : ' + type + ' ' + data.name)
                const formData = getFormData(pf)
                const requireInputs = data.ajax.url.match(/(\{{2}[A-Za-z_]+\}{2})+/g)
                let { url } = data.ajax
                if (data.ajax.form) {
                    url = 'app/modules/'
                        + data.ajax.form[0]
                        + '/forms/'
                        + data.ajax.form[1]
                        + '.php?'
                        + 'incOpp=form&incModule='
                        + data.ajax.form[0]
                        + '&incForm='
                        + data.ajax.form[1]
                        + url.replace('?', '&')
                }

                $.each(requireInputs, function () {
                    const replaceVar = this
                    const replaceInput = this.replace('{{', '').replace('}}', '')
                    // let replaceInputEl = pf.find('[data-id="' + replaceInput + '"]')
                    // let replaceOut = replaceInputEl.val()
                    let replaceOut = formData[replaceInput]

                    if (
                        data.map &&
                        data.map[replaceInput] &&
                        data.map[replaceInput][replaceOut]
                    ) {
                        replaceOut = data.map[replaceInput][replaceOut]
                    }

                    if ($.isPlainObject(replaceOut)) {
                        replaceOut = encodeURIComponent(JSON.stringify(replaceOut));
                    }

                    if (replaceOut === undefined || replaceOut === null) {
                        replaceOut = ''
                    }

                    // console.log('REPLACE');
                    // console.log(replaceVar);
                    // console.log(replaceVar);

                    url = url.replace(replaceVar, replaceOut)
                })
                if (data.clear) data.clear()
                const historyUrl = (url.split('incForm=')[1] || '').split('&').reduce((params, param) => {
                    const [key, value] = param.split('=');
                    if (key && value) params[key] = value;
                    return params;
                }, {});
                historyAdd(global.pageId, '&'+urlSerialize(historyUrl))
                let qFormData = getFormData(input, true);
                ajaxCall({
                    url,
                    method: 'POST',
                    dataType: (data.ajaxType) ? data.ajaxType : 'json',
                    data: {
                        form: qFormData,
                    },
                    callback(response) {
                        input.removeClass('loading')
                        // const responseData = response.data
                        if (data.update) data.update(data, response)
                        if (data.ajax.js) loadModuleScript(data.ajax.js)
                    },
                    error(response) {
                        input.removeClass('loading')
                    }
                })
            }

            if (apiDeferreds.length > 0) {
                $.when.apply($, apiDeferreds).always(proceedWithAjax)
            } else {
                proceedWithAjax()
            }
        }

        // apply field action
        const requireInputs = data.ajax.url.match(/(\{{2}[A-Za-z_]+\}{2})+/g)
        $.each(requireInputs, function () {
            const replaceInput = this.replace('{{', '').replace('}}', '')
            const eventNamespace = 'change.ajax_' + (input.attr('id') || name || 'field') + '_' + replaceInput
            pf.off(eventNamespace).on(eventNamespace, '[data-id="' + replaceInput + '"], [name="' + replaceInput + '"]', function () {
                setTimeout(function() {
                    if (input.data('noQ') || global.noQ) return false
                    if ($('#' + input.attr('id')).length || input.closest('body').length) {
                        data.reload()
                    }
                }, 1)
            })
        })
        // data.reload()
    }
    return data
}
